<template>
  <div class="flex flex-col w-full h-full gap-y-2">

    <div class="border-b border-eblack-300">
      <ul
        class="flex flex-wrap -mb-px text-sm font-medium text-center text-eblack-950 bg-eblack-100/70 rounded-t-md pt-0.5 px-0.5"
      >
        <li class="me-2">
          <button
            type="button"
            @click="tab = 1"
            v-bind:class="[
              tab == 1
                ? 'bg-white border-b border-eorange-300'
                : 'border-transparent',
            ]"
            class="inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 group"
          >
            <svg
              class="w-4 h-4 text-gray-400 me-2 group-hover:text-gray-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 18 20"
            >
              <path
                d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"
              />
            </svg>{{ $t("packages.auto.formulario") }}</button>
        </li>
        <li class="me-2">
          <button
            type="button"
            @click="tab = 2"
            v-bind:class="[
              tab == 2
                ? 'bg-white border-b border-eorange-300'
                : 'border-transparent ',
            ]"
            class="inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 group"
          >
            <svg
              class="w-4 h-4 text-gray-400 me-2 group-hover:text-gray-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M4.857 3A1.857 1.857 0 0 0 3 4.857v4.286C3 10.169 3.831 11 4.857 11h4.286A1.857 1.857 0 0 0 11 9.143V4.857A1.857 1.857 0 0 0 9.143 3H4.857Zm10 0A1.857 1.857 0 0 0 13 4.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 9.143V4.857A1.857 1.857 0 0 0 19.143 3h-4.286Zm-10 10A1.857 1.857 0 0 0 3 14.857v4.286C3 20.169 3.831 21 4.857 21h4.286A1.857 1.857 0 0 0 11 19.143v-4.286A1.857 1.857 0 0 0 9.143 13H4.857ZM18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z"
                clip-rule="evenodd"
              />
            </svg>{{ $t("packages.auto.servicios") }}</button>
        </li>
      </ul>
    </div>

    <FormTab
      v-show="tab == 1"
      :setForm="setForm"
      :errors="errors"
      ref="formTab"
    />

    <ServicesTab v-show="tab == 2" :services="services" ref="serviceTab" />

    <div class="flex items-start mt-auto">
      <button
        type="button"
        class="bg-green-500 text-white px-2 py-1.5 rounded-md mb-2"
        @click="action()"
      >
        {{ button_text }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { i18n } from "@/i18n";
import { ref, watch, onMounted, computed } from 'vue';
import { useToast } from 'vue-toastification';
import { useServiceStore } from '@domains/service/stores/service.store';
import packageRequest from '@/services/admin/package-service.js';
import FormTab from '../components/FormTab.vue';
import ServicesTab from '../components/ServicesTab.vue';

const props = defineProps({
  closeModal: { type: Function, default: null },
  loadData: { type: Function, required: true },
  package: { type: Object, default: null },
  overlayService: { type: Object, default: null }
});

const toast = useToast();
const serviceStore = useServiceStore();

const formTab = ref(null);
const serviceTab = ref(null);
const tab = ref(1);
const id = ref(0);
const errors = ref([]);

const form = ref({
  name: '',
  description: '',
  duration: '',
  services: [],
  state: 'A',
});

const services = computed(() => serviceStore.services);
const button_text = computed(() => id.value === 0 ? 'Guardar' : 'Actualizar');

watch(() => props.package, (value) => {
  if (value) {
    const temp_data = { ...value };
    id.value = temp_data.id;
    form.value.name = temp_data.name;
    form.value.duration = temp_data.duration;
    form.value.description = temp_data.description;
    form.value.services = temp_data.services.map((service) => service.id);

    if (formTab.value) {
      formTab.value.form = form.value;
    }
    if (serviceTab.value) {
      serviceTab.value.selectedServices = form.value.services;
    }
  }
}, { immediate: true });

function setForm(formData) {
  console.log(formData);
}

function action() {
  const refForm = formTab.value?.form || {};
  form.value = { ...refForm, services: [] };
  form.value.services = serviceTab.value?.selectedServices || [];

  if (id.value === 0) {
    save();
  } else {
    update();
  }
}

async function save() {
  try {
    const res = await packageRequest.savePackage(form.value);
    if (res.status === 201) {
      resetForm();
      props.loadData();
      if (props.overlayService) {
        props.overlayService.closeTop(true);
      } else if (props.closeModal) {
        props.closeModal();
      }
      toast.success(i18n.global.t("packages.auto.paquete_guardado_correctamente"), { timeout: 3000, position: 'top-right' });
    }
  } catch (error) {
    errors.value = readValidationErrors(error);
  }
}

async function update() {
  try {
    const res = await packageRequest.updatePackage(id.value, form.value);
    if (res.status === 200) {
      resetForm();
      props.loadData();
      if (props.overlayService) {
        props.overlayService.closeTop(true);
      } else if (props.closeModal) {
        props.closeModal();
      }
      toast.success(i18n.global.t("packages.auto.paquete_actualizado_correctamente"), { timeout: 3000, position: 'top-right' });
    }
  } catch (error) {
    errors.value = readValidationErrors(error);
  }
}

function readValidationErrors(error) {
  const message = error?.response?.data?.message;
  return Array.isArray(message) ? message : [];
}

function resetForm() {
  form.value = {
    name: '',
    description: '',
    duration: '',
    services: [],
    state: 'A',
  };
}

onMounted(async () => {
  await serviceStore.fetchServices();
});
</script>

<style lang="scss" scoped></style>
